<template>
  <div class="musoon">
    <img src="@/assets/images/logo.jpg" />
    <p>木生婦產科診所</p>
    <br />
    <router-link to="/guest/develop/HomePage">LINE</router-link>
    <hr />
    <router-link to="/guest/web/Appointment/">官網網路預約</router-link>
    <router-link to="/guest/web/Appointment/婦產科">婦產科</router-link>
    <router-link to="/guest/web/Appointment/婦產科/李木生"
      >Lee Musoon</router-link
    >
    <hr />
    <router-link to="/guest/develop/Appointment/">網路預約</router-link>
    <router-link to="/guest/develop/Appointment/婦產科">婦產科</router-link>
    <router-link to="/guest/develop/Appointment/婦產科/李木生"
      >Lee Musoon</router-link
    >
    <router-link to="/guest/develop/AppointmentQuery/">預約查詢</router-link>
    <router-link to="/guest/develop/CheckIn">就診報到</router-link>
    <router-link to="/guest/develop/CheckInQRCode">QRCode 報到</router-link>
    <router-link to="/guest/develop/WaitInfo">候診資訊</router-link>
    <router-link to="/guest/develop/Notification">推播</router-link>
    <router-link to="/guest/develop/FeedBack">意見反饋</router-link>
    <router-link to="/guest/develop/MedicalInfo">檢驗報告</router-link>
    <router-link to="/guest/develop/SurveyVisit">門診部滿意度調查</router-link>
    <router-link to="/guest/develop/SurveyRoom">病房部滿意度調查</router-link>
    <router-link to="/guest/develop/SurveyPostpartum"
      >產後護理滿意度調查</router-link
    >
    <router-link to="/guest/develop/MemberShip">我的</router-link>
    <hr />
    <router-link to="/guest/develop/FirstVisitForm">初診問診單</router-link>
    <router-link to="/guest/pad/FirstVisitForm">初診問診單(Pad)</router-link>
    <router-link to="/guest/musoon/FirstVisitForm">初診問診單(PC)</router-link>
    <router-link to="/guest/musoon/FirstVisitForm/1111111"
      >初診問診單(醫師台)</router-link
    >
    <router-link to="/guest/develop/VIPReservation">VIP預約</router-link>

    <router-link to="/guest/develop/Operation">手術清單</router-link>

    <router-link to="/guest/develop/SignUp">Sign Up</router-link>
    <router-link to="/guest/develop/Login">Login</router-link>
  </div>
  <hr />
  <div class="info">
    Debug: {{ debug }}<br />
    Stage: {{ stage }}<br />
    Ver: {{ version }}<br />
    LIFF IDs<br />
    {{ liffIds }}
  </div>
</template>

<style scoped>
a {
  line-height: 1.8rem;
}
.musoon {
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
}
img {
  width: 6rem;
  margin: 1.2rem;
}
.info {
  margin: 2rem;
}
</style>

<script>
export default {
  data() {
    return {
      debug: eval(process.env.VUE_APP_DEBUG),
      stage: process.env.VUE_APP_STAGE,
      version: process.env.VUE_APP_VERSION,
      liffIds: JSON.parse(process.env.VUE_APP_LIFFID)[process.env.VUE_APP_STAGE]
    };
  },
  mounted() {
    //this.$router.push("/guest/web/Appointment");
  }
};
</script>
